import $ from 'jquery';

let itemHidden = $('.faq-item > .faq-item__hidden');
let itemShown = $('.faq-item > .faq-item__shown');

itemHidden.slideUp();

itemShown.on('click', function () {
  if ($(this).parent().hasClass('open')) {
    $(this).parent().removeClass('open');
    $(this).next().slideUp();
    return false;
  } else {
    $(this).next().slideDown();
    $(this).parent().addClass('open');
    return false;
  }
});
